import React from 'react';
import TodoFeature from '../../../components/common/todo-feature';

export default function ProductionCostAnalysis() {
  return (
    <div className="container mx-auto">
      <TodoFeature name="Finance production cost analysis – skat. MALA-316" />
    </div>
  );
}
